import { Modal } from 'antd';
import { any, bool, element, func, string } from 'prop-types';
import React from 'react';

const FormModal = (props) => {
    const {
        visible,
        title,
        width,
        placement = 'right',
        formComponent,
        extraComponent,
        onClose,
        getContainer = true,
        closable = false,
        className,
        maskClosable = true,
        destroyOnClose = true,
        footer,
        centered = false,
    } = props;

    return (
        <Modal
            closable={closable}
            title={title}
            width={width || 800}
            onCancel={onClose}
            visible={visible}
            footer={footer}
            style={{
                overflow: 'auto',
                position: getContainer === false ? 'absolute !important' : null,
            }}
            getContainer={getContainer}
            className={className}
            maskClosable={maskClosable}
            destroyOnClose={destroyOnClose}
            centered={centered}>
            {formComponent}
        </Modal>
    );
};

FormModal.propTypes = {
    visible: bool,
    title: string,
    width: string,
    placement: string,
    formComponent: element,
    extraComponent: element,
    onClose: func,
    closable: bool,
    getContainer: bool,
    className: string,
    maskClosable: bool,
    destroyOnClose: bool,
    footer: any,
    centered: bool,
};

export default FormModal;
